import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../../../Actions/Dashboard';

import Grid from '@material-ui/core/Grid';
import { colors5 } from '../../../../constants/icons/characteristics/Characteristics';

import ChartMenu from '../ChartMenu/ChartMenu'
// import CustomTooltip from './DoughnutTooltip';



class TotalComponent extends Component {

  getData = () => {
    const { data } = this.props;
    let resp = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i] !== 0) {
        let temp = {
          name: i.toString(),
          val: data[i]
        }
        resp.push(temp);
      }
    }
    return resp;
  }

  getTotal = () => {
    const { data } = this.props;
    let resp = 0;
    for (let i = 0; i < data.length; i++) {
      resp += data[i];
    }
    return <p style={{ fontWeight: 'bold' }}>{'Total: ' + resp} </p>;
  }

  onClick = (uno, dos) => {
    console.log({ id: this.props.data.name.split('_')[1], value: this.props.title })
    this.props.actions.selectFilter({ id: this.props.data.name.split('_')[1], value: this.props.title }, 'ep')
  }

  getColor = () => {
    return colors5[1 % colors5.length]
  }


  render() {
    return (
      <Grid style={{ flexWrap: "inherit", margin: 'auto' }} id={this.props.name}>
        <ChartMenu graph={this.props.name} file={this.props.title}
          openDialog={this.props.openDialog} title={this.props.title} watch={this.props.watchMenu}
          seeMore={this.props.seeMore} />
        <div className='flex-center cursor-pointer' onClick={this.onClick} >
          <p className='text-total' style={{ color: this.props.colors }}>{this.props.data.dataSet[0].value}</p>
        </div>
      </Grid>
    )
  }
}

function mapDispathToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

export default connect(null, mapDispathToProps)(TotalComponent);
